export const CorefacultysActions = {
  GET_COREFACULTY_SECTION: "GET_COREFACULTY_SECTION",
  SET_COREFACULTY_SECTION: "SET_COREFACULTY_SECTION",
};
